import { PartnerPracticeAddress } from '@/shared/partner-practice-address';
import { PartnerPracticeEmailAttachment } from '@/shared/partner-practice-email-attachment';
import { User } from '@/shared/user';

export interface PartnerPractice {
    id?: string | null;
    name: string | null;
    email: string | null;
    telephone: string | null;
    isSimpsonsSolicitors: boolean;
    isArchived?: boolean;
    version?: number;
    createdDate?: string;
    createdBy?: string;
    lastModifiedDate?: string | null;
    lastModifiedBy?: string | null;
    addresses: Array<PartnerPracticeAddress>;
    emailAttachments: Array<PartnerPracticeEmailAttachment>;
    originalSourceTypes: Array<string>;
    users?: Array<User>;
}

export function createPartnerPractice(): PartnerPractice {
    return {
        name: '',
        email: '',
        telephone: '',
        isSimpsonsSolicitors: false,
        addresses: new Array<PartnerPracticeAddress>(),
        originalSourceTypes: new Array<string>(),
        emailAttachments: new Array<PartnerPracticeEmailAttachment>(),
    };
}
